var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-footer"},[(!_vm.isMobile)?_c('footerWeb'):_vm._e(),(_vm.isMobile)?_c('footerMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }